<template>
  <div class="confirmationDelete text-left" :style="customStyleModal">
    <div class="confirmationDelete__header">
      <p class="confirmationDelete__title font-weight-semi-bold mb-1" v-html="title || $t(`general.component.deleteList.title`)"></p>
    </div>
    <div class="confirmationDelete__body">
      <p class="confirmationDelete__description text-gray-700" v-html="description || $t(`general.component.deleteList.descriptionDefault`)"></p>
    </div>
    <div class="confirmationDelete__footer">
      <div class="confirmationDelete__actions" :style="customStyleConfirmActions">
        <CButton data-cy="cancelDelete" class="px-3 py-2 mr-2" @click.stop="cancel" :disabled="loadingConfirm">{{
          cancelText || $t('campaign.campaignList.cancel-delete')
        }}</CButton>
        <CButton data-cy="confirmDelete" class="px-3 py-2 btn btn-primary" @click.stop="confirm" :disabled="loadingConfirm">
          <CSpinner v-if="loadingConfirm" class="mr-1" color="custom-color" style="width: 1.1rem; height: 1.1rem" />
          <span>{{ confirmText || $t('campaign.campaignList.confirm-delete') }}</span>
        </CButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationDelete',
  props: {
    loadingConfirm: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    customStyleModal: {
      type: String,
      default: () => 'width: 250px',
    },
    customStyleConfirmActions: {
      type: String,
    },
    confirmText: {
      type: String,
    },
    cancelText: {
      type: String,
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    },

    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>
